// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const persian: PokeData = {
  "id": 53,
  "name": "persian",
  "height": 10,
  "weight": 320,
  "base_experience": 154,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "pay-day",
    "scratch",
    "bite",
    "growl",
    "hypnosis",
    "screech",
    "swift",
    "amnesia",
    "fury-swipes",
    "slash",
    "feint-attack",
    "swagger",
    "fake-out",
    "taunt",
    "feint",
    "assurance",
    "night-slash",
    "power-gem",
    "switcheroo",
    "nasty-plot",
    "captivate",
    "play-rough"
  ],
  "moves": [
    "scratch",
    "bite",
    "growl",
    "night-slash",
    "play-rough",
    "scary-face",
    "quick-attack",
    "headbutt",
    "protect",
    "leer",
    "refresh",
    "tackle",
    "supersonic"
  ],
  "evolution_chain": {
    "id": 22,
    "item": null,
    "species": [
      {
        "name": "meowth",
        "order": 57,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "persian",
        "order": 58,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 52,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "perrserker",
        "order": 863,
        "types": [
          PokeType.STEEL
        ],
        "evolves_from_species_id": 52,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 103,
    "speed": 185,
    "ability_power": 113
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
